import {
	Create,
	NumberInput,
	SelectInput,
	SimpleForm,
	TextInput,
} from "react-admin";

export const PartnerEarningCreate = () => (
	<Create>
		<SimpleForm>
			<TextInput source="appId" label="App ID" required />
			<TextInput source="partnerId" label="Partner ID" required />
			<TextInput source="installId" label="Install ID" required />
			<TextInput source="transactionId" label="Transaction ID" required />
			<NumberInput
				source="amountCentsUSD"
				label="Amount (cents USD)"
				required
			/>
			<SelectInput
				source="status"
				required
				choices={[
					{ id: "accrued", name: "Accrued" },
					{ id: "processing", name: "Processing" },
					{ id: "unpayable", name: "Unpayable" },
					{ id: "void", name: "Void" },
					{ id: "paid", name: "Paid" },
				]}
			/>
		</SimpleForm>
	</Create>
);
